<template>
  <div>
    <div class="dataShow_data">
          <div
            class="dataShow_dataItem"
            v-for="(item, index) in 7"
            :key="index"
            @click="toDetail"
          >
            <div class="dataShow_dataItemImgBox">
              <el-image
                style="width: 100%; height: 100%"
                :src="dataImg"
                fit="cover"
              ></el-image>
            </div>
            <div class="dataShow_dataItemInfoBox">
              <div class="dataShow_dataItemInfoMoney">￥18888</div>
              <div class="dataShow_dataItemInfo of-2">
                981-2015年中国地区多源多时相遥感备份
              </div>
              <div class="dataShow_dataItemData">
                <div class="dataShow_dataItemTime">
                  2021-12-19
                </div>
                <div class="dataShow_dataItemTag">
                  <el-tag type="info" style="margin-right:10px;">GH1</el-tag>
                  <el-tag type="info" style="margin-right:10px;">16m</el-tag>
                </div>
                <div class="dataShow_dataItemTalk">
                  <span style="color:#2469f1;">4100+条</span>  评价
                </div>
              </div>
            </div>
            
              <div class="dataShow_dataItemBtn">
                立即购买
              </div>
          </div>
        </div>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      dataImg: require("@/assets/imgs/RemoteSensingMall/dataImg.png"),
    };
  },
  mounted() {},
  methods: {
    toDetail(){
      this.$router.push({ path:'/shopDetail'  })
    },
  },
};
</script>
<style lang="scss" scoped>
.dataShow_dataItemBtn{
  height: 40px;
  line-height: 40px;
  background-color: #2469f1;
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.dataShow_dataItemData{
  display:flex;justify-content: space-between;align-items:center;
}
.dataShow_dataItemTalk{
font-size: 14px;
}
.dataShow_dataItemTag{
font-size: 14px;
}
.dataShow_dataItemTime{
font-size: 14px;
color: #ccc;
}
.dataShow_dataItemInfo {
  font-size: 14px;
  width: 100%;
  height: 28px;
  line-height: 14px;
  margin-bottom: 10px;
}
.dataShow_dataItemInfoMoney {
  margin-bottom: 10px;
  font-weight: bold;
  color: #e24087;
}
.dataShow_dataItemInfoBox {
  padding: 10px;
}
.dataShow_dataItemImgBox {
  width: 100%;
  height: 210px;
}
.dataShow_dataItem {
  width: 24%;
  margin-bottom: 10px;
  background: #fff;
  border: 1px solid #ccc;
}
/* 如果最后一行是3个元素 */
.dataShow_dataItem:last-child:nth-child(4n - 1) {
    margin-right: calc(24% + 4% / 3);
}
/* 如果最后一行是2个元素 */
.dataShow_dataItem:last-child:nth-child(4n - 2) {
    margin-right: calc(48% + 7.7% / 3);
}
.dataShow_dataItem:hover{
  box-shadow: 0px 0px  5px #8fbbee;
  border: 1px solid #8fbbee;
  cursor: pointer;
}
.dataShow_rank {
  width: 25%;
  padding: 20px;
  background: #f5f7fa;
}
.dataShow_data {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #f5f7fa;
}
</style>